// extracted by mini-css-extract-plugin
export default {"container":"LanguagePills_container__V898z","pill":"LanguagePills_pill__CJ8U7","label":"LanguagePills_label__P6fwQ"};